import { useQuery } from '@tanstack/react-query'
import { dashboardApi } from '@/api/dashboard'
import { ContinueLearningCard } from '@/components/dashboard/ContinueLearningCard'
import { CoachNoteCard } from '@/components/dashboard/CoachNoteCard'
import { DashboardStatsPanel } from '@/components/dashboard/DashboardStatsPanel'
import { TodayPlanWidget } from '@/components/dashboard/TodayPlanWidget'
import { ExploreCatalogLink } from '@/components/catalog/ExploreCatalogLink'
import { QuietFeedbackCta } from '@/components/feedback/QuietFeedbackCta'
import { DashboardSkeleton } from '@/components/DashboardSkeleton'
import { ErrorScreen } from '@/components/ErrorScreen'

export function DashboardPage() {
  const { data, isLoading, isError, refetch } = useQuery({
    queryKey: ['dashboard'],
    queryFn: () => dashboardApi.getDashboard(),
    staleTime: 1000 * 60,
  })

  if (isLoading) {
    return <DashboardSkeleton />
  }

  if (isError || !data) {
    return (
      <ErrorScreen
        variant="network"
        title="Failed to load dashboard"
        description="We couldn't load your dashboard. Please check your connection and try again."
        onRetry={() => refetch()}
      />
    )
  }

  return (
    <div className="space-y-4">
      <CoachNoteCard coachNote={data.coachNote} />
      <ContinueLearningCard continueLearning={data.continueLearning} isNewUser={data.isNewUser} />
      <QuietFeedbackCta testId="dashboard-feedback-cta" />
      <DashboardStatsPanel
        growth={data.growth}
        streak={data.streak}
        vocabularyStats={data.vocabularyStats}
        isNewUser={data.isNewUser}
      />
      <TodayPlanWidget plan={data.todayPlan} isNewUser={data.isNewUser} />
      <ExploreCatalogLink />
    </div>
  )
}
